import { combinedApi as api } from "../combinedApi";
export const addTagTypes = ["TransformerModel"] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes,
  })
  .injectEndpoints({
    endpoints: (build) => ({
      getTransformerModel: build.query<
        GetTransformerModelApiResponse,
        GetTransformerModelApiArg
      >({
        query: () => ({ url: `/TransformerModel` }),
        providesTags: ["TransformerModel"],
      }),
      postTransformerModel: build.mutation<
        PostTransformerModelApiResponse,
        PostTransformerModelApiArg
      >({
        query: (queryArg) => ({
          url: `/TransformerModel`,
          method: "POST",
          body: queryArg,
        }),
        invalidatesTags: ["TransformerModel"],
      }),
      putTransformerModelById: build.mutation<
        PutTransformerModelByIdApiResponse,
        PutTransformerModelByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/TransformerModel/${queryArg.id}`,
          method: "PUT",
          body: queryArg.transformerModelDto,
        }),
        invalidatesTags: ["TransformerModel"],
      }),
      deleteTransformerModelById: build.mutation<
        DeleteTransformerModelByIdApiResponse,
        DeleteTransformerModelByIdApiArg
      >({
        query: (queryArg) => ({
          url: `/TransformerModel/${queryArg}`,
          method: "DELETE",
        }),
        invalidatesTags: ["TransformerModel"],
      }),
      getTransformerModelByIdAttachment: build.query<
        GetTransformerModelByIdAttachmentApiResponse,
        GetTransformerModelByIdAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/TransformerModel/${queryArg}/attachment`,
        }),
        providesTags: ["TransformerModel"],
      }),
      postTransformerModelByIdAttachment: build.mutation<
        PostTransformerModelByIdAttachmentApiResponse,
        PostTransformerModelByIdAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/TransformerModel/${queryArg.id}/attachment`,
          method: "POST",
          params: { fileName: queryArg.fileName },
        }),
        invalidatesTags: ["TransformerModel"],
      }),
      deleteTransformerModelByIdAttachment: build.mutation<
        DeleteTransformerModelByIdAttachmentApiResponse,
        DeleteTransformerModelByIdAttachmentApiArg
      >({
        query: (queryArg) => ({
          url: `/TransformerModel/${queryArg}/attachment`,
          method: "DELETE",
        }),
        invalidatesTags: ["TransformerModel"],
      }),
    }),
    overrideExisting: false,
  });
export { injectedRtkApi as transformerModelApi };
export type GetTransformerModelApiResponse =
  /** status 200 OK */ TransformerModelDto[];
export type GetTransformerModelApiArg = void;
export type PostTransformerModelApiResponse = /** status 201 Created */ number;
export type PostTransformerModelApiArg = TransformerModelDto;
export type PutTransformerModelByIdApiResponse = /** status 200 OK */ void;
export type PutTransformerModelByIdApiArg = {
  id: number;
  transformerModelDto: TransformerModelDto;
};
export type DeleteTransformerModelByIdApiResponse = unknown;
export type DeleteTransformerModelByIdApiArg = number;
export type GetTransformerModelByIdAttachmentApiResponse =
  /** status 200 OK */ string;
export type GetTransformerModelByIdAttachmentApiArg = number;
export type PostTransformerModelByIdAttachmentApiResponse =
  /** status 200 OK */ string;
export type PostTransformerModelByIdAttachmentApiArg = {
  fileName: string;
  id: number;
};
export type DeleteTransformerModelByIdAttachmentApiResponse = unknown;
export type DeleteTransformerModelByIdAttachmentApiArg = number;
export type TransformerModelType = "voltage" | "current" | "combi";
export type TransformerModelDto = {
  id: number;
  manufacturer: string;
  model: string;
  type: TransformerModelType;
  frequencyThreshold10Percent?: number | null;
  frequencyThreshold5Percent?: number | null;
  frequencyThreshold1Percent?: number | null;
  s3Key?: string | null;
  comment?: string | null;
};
export type ProblemDetails = {
  type?: string | null;
  title?: string | null;
  status?: number | null;
  detail?: string | null;
  instance?: string | null;
  [key: string]: any;
};
export const {
  useGetTransformerModelQuery,
  useLazyGetTransformerModelQuery,
  usePostTransformerModelMutation,
  usePutTransformerModelByIdMutation,
  useDeleteTransformerModelByIdMutation,
  useGetTransformerModelByIdAttachmentQuery,
  useLazyGetTransformerModelByIdAttachmentQuery,
  usePostTransformerModelByIdAttachmentMutation,
  useDeleteTransformerModelByIdAttachmentMutation,
} = injectedRtkApi;
